import axios from 'axios';
import { toastr } from 'react-redux-toastr';
import { createAction } from 'redux-act';
import { url } from 'utils/url';
import { log, errorMsg, refreshToken } from 'utils';

export const CONFIGS_FETCH_DATA_INIT = createAction('CONFIGS_FETCH_DATA_INIT');
export const CONFIGS_FETCH_DATA_SUCCESS = createAction('CONFIGS_FETCH_DATA_SUCCESS');
export const CONFIGS_FETCH_DATA_FAIL = createAction('CONFIGS_FETCH_DATA_FAIL');

export const CONFIGS_DELETE_CONFIG_INIT = createAction('CONFIGS_DELETE_CONFIG_INIT');
export const CONFIGS_DELETE_CONFIG_SUCCESS = createAction('CONFIGS_DELETE_CONFIG_SUCCESS');
export const CONFIGS_DELETE_CONFIG_FAIL = createAction('CONFIGS_DELETE_CONFIG_FAIL');

export const CONFIGS_CREATE_CONFIG_INIT = createAction('CONFIGS_CREATE_CONFIG_INIT');
export const CONFIGS_CREATE_CONFIG_SUCCESS = createAction('CONFIGS_CREATE_CONFIG_SUCCESS');
export const CONFIGS_CREATE_CONFIG_FAIL = createAction('CONFIGS_CREATE_CONFIG_FAIL');

export const CONFIGS_MODIFY_CONFIG_INIT = createAction('CONFIGS_MODIFY_CONFIG_INIT');
export const CONFIGS_MODIFY_CONFIG_SUCCESS = createAction('CONFIGS_MODIFY_CONFIG_SUCCESS');
export const CONFIGS_MODIFY_CONFIG_FAIL = createAction('CONFIGS_MODIFY_CONFIG_FAIL');

export const CONFIGS_CLEAN_UP = createAction('CONFIGS_CLEAN_UP');
export const CONFIGS_CLEAR_DATA_LOGOUT = createAction('CONFIGS_CLEAR_DATA_LOGOUT');

export const SET_CONFIG_TAB = createAction('SET_CONFIG_TAB');
export const SET_ACTIVE_CONFIG = createAction('SET_ACTIVE_CONFIG');

export const fetchConfigs = ({ siteId }) => async (dispatch) => {
  dispatch(CONFIGS_FETCH_DATA_INIT());
  try {
    const token = await refreshToken();
    const res = await axios.get(`${url}/configuration/`, {
      params: { siteId },
      headers: { Authorization: `Bearer ${token}` },
    });
    const config = res.data.data;
    log(config, 'config response');
    return dispatch(CONFIGS_FETCH_DATA_SUCCESS({ config }));
  } catch (error) {
    toastr.error('', `${errorMsg(dispatch, error)}`);
    return dispatch(CONFIGS_FETCH_DATA_FAIL({ error }));
  }
};

export const configsCleanUp = () => (dispatch) => dispatch(CONFIGS_CLEAN_UP());

export const setActiveTab = (tab) => (dispatch) => dispatch(SET_CONFIG_TAB(tab));

export const setActiveConfig = (config, cb) => (dispatch) => {
  dispatch(SET_ACTIVE_CONFIG(config));
  if (cb) cb();
};
